import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import ru from "./ru.json";
import en from "./en.json";
import kk from "./kk.json";

// Russian is canonical. English provides full coverage. Kazakh is partial
// (community-marked) and falls back to Russian for any missing key.
export const SUPPORTED_LOCALES = ["ru", "en", "kk"];
export const DEFAULT_LOCALE = "ru";

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      ru: { translation: ru },
      en: { translation: en },
      kk: { translation: kk },
    },
    fallbackLng: { kk: ["ru"], default: ["ru"] },
    lng: DEFAULT_LOCALE,
    supportedLngs: SUPPORTED_LOCALES,
    detection: {
      order: ["localStorage", "navigator"],
      lookupLocalStorage: "edoc.locale",
      caches: ["localStorage"],
    },
    interpolation: { escapeValue: false },
    returnEmptyString: false,
    react: { useSuspense: false },
  });

// Keep <html lang="…"> in sync so screen readers, axe-core, and search
// engines see the right locale.
function syncHtmlLang(lng) {
  if (typeof document !== "undefined") {
    document.documentElement.lang = (lng || DEFAULT_LOCALE).split("-")[0];
  }
}
syncHtmlLang(i18n.language || DEFAULT_LOCALE);
i18n.on("languageChanged", syncHtmlLang);

export default i18n;
